import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ProvisionChange } from '../../models/provisionchange';

@Pipe({
  standalone: false,
  name: 'sortaddedfpcs'
})

@Injectable()
export class SortAddedFpcsPipe implements PipeTransform {
  transform(items: ProvisionChange[]): any[] {
    if (!items) return [];
    if (items.length === 0) return [];
    
    return items.filter(item => item.ToExecution != null && item.FromExecution == null);
  }
}